// src/ui/features/calculator/components/CalculatorHeaderCard.jsx
import React from "react";
import Card from "../ui/Card";
import Pill from "../ui/Pill";

export default function CalculatorHeaderCard({
  headerTitle,
  ruleset,
  loading,
  loadError,
}) {
  return (
    <Card className="p-6">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h1 className="text-lg font-semibold tracking-tight sm:text-xl">
            {headerTitle}
          </h1>
          <p className="mt-1 text-sm text-neutral-600 dark:text-neutral-400">
            Enter module grades and credits. The calculator uses your university’s
            published ruleset.
          </p>

          <div className="mt-4 rounded-lg border border-neutral-200 bg-neutral-50 px-3 py-2 text-xs text-neutral-600 dark:border-neutral-800 dark:bg-neutral-900 dark:text-neutral-400">
            This calculator provides an <span className="font-medium">estimate</span>{" "}
            based on the published ruleset. Final degree outcomes are determined by
            the university and may differ due to discretionary, borderline, or
            regulatory factors.
          </div>

          <div className="mt-3 flex flex-wrap gap-2">
            {ruleset?.meta?.version ? <Pill>Version: {ruleset.meta.version}</Pill> : null}
            {ruleset?.meta?.source ? <Pill>Source: {ruleset.meta.source}</Pill> : null}
          </div>
        </div>
      </div>

      {loading ? (
        <div className="mt-4 text-sm text-neutral-600 dark:text-neutral-400">
          Loading ruleset…
        </div>
      ) : null}

      {loadError ? (
        <div className="mt-4 rounded-xl border border-neutral-200 bg-neutral-50 p-3 text-sm text-neutral-700 dark:border-neutral-800 dark:bg-neutral-950 dark:text-neutral-300">
          {loadError}
        </div>
      ) : null}
    </Card>
  );
}
